/* Actions and countdowns for snippets/elxr-button.liquid and the CTA blocks. */
(function () {
  if (window.ElxrCta) return;

  function buyBoxTarget() {
    if (typeof Elixir_ProductFormExists === 'function' && Elixir_ProductFormExists()) {
      var form = Elixir_GetProductForm();
      return form.closest('.shopify-section') || form;
    }
    return document.getElementById('order') || document.querySelector('[id^="MainProduct"]');
  }

  function scrollToTarget(selector) {
    var target = null;
    if (selector && selector !== '#') {
      try {
        target = document.querySelector(selector);
      } catch (e) {
        target = null;
      }
    }
    target = target || buyBoxTarget();
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-elxr-cta-action]');
    if (!button) return;
    var action = button.getAttribute('data-elxr-cta-action');

    if (action === 'scroll') {
      if (scrollToTarget(button.getAttribute('data-elxr-cta-target'))) event.preventDefault();
      return;
    }

    if (action === 'add_to_cart') {
      event.preventDefault();
      if (typeof Elixir_ProductFormExists === 'function' && Elixir_ProductFormExists()) {
        var form = Elixir_GetProductForm();
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      } else {
        scrollToTarget(null);
      }
    }
  });

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function startTimer(el) {
    if (el.getAttribute('data-elxr-cta-timer-started')) return;
    el.setAttribute('data-elxr-cta-timer-started', '1');
    var minutes = parseInt(el.getAttribute('data-elxr-cta-timer'), 10) || 15;
    var key = 'elxr-cta-timer-' + (el.getAttribute('data-elxr-cta-timer-key') || minutes);
    var end = 0;
    try {
      end = parseInt(sessionStorage.getItem(key), 10) || 0;
    } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      try {
        sessionStorage.setItem(key, String(end));
      } catch (e) {}
    }

    function tick() {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (left === 0) {
        end = Date.now() + minutes * 60000;
        try {
          sessionStorage.setItem(key, String(end));
        } catch (e) {}
        left = minutes * 60;
      }
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      el.textContent = (h ? h + ':' + pad(m) : pad(m)) + ':' + pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  var DATE_OPTIONS = {
    '%b %-d': { month: 'short', day: 'numeric' },
    '%a, %b %-d': { weekday: 'short', month: 'short', day: 'numeric' },
    '%-d %b': { day: 'numeric', month: 'short' }
  };

  // Liquid renders the delivery dates at cache time; recount from the visitor's today so cached pages stay correct.
  function refreshShipping(line) {
    var skip = line.getAttribute('data-skip-weekends') === 'true';
    var options = DATE_OPTIONS[line.getAttribute('data-format')] || DATE_OPTIONS['%b %-d'];
    var locale = document.documentElement.lang || undefined;
    line.querySelectorAll('[data-elxr-cta-days]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-elxr-cta-days'), 10) || 0;
      var date = new Date();
      var counted = 0;
      while (counted < days) {
        date.setDate(date.getDate() + 1);
        var dow = date.getDay();
        if (skip && (dow === 0 || dow === 6)) continue;
        counted += 1;
      }
      try {
        el.textContent = date.toLocaleDateString(locale, options);
      } catch (e) {}
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-elxr-cta-timer]').forEach(startTimer);
    (scope || document).querySelectorAll('[data-elxr-cta-shipping]').forEach(refreshShipping);
  }

  window.ElxrCta = { init: init, scrollTo: scrollToTarget };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
